function addFloatClass(wrapper) {
  wrapper.classList.add('should-float');
}

function removeFloatClass(wrapper) {
  wrapper.classList.remove('should-float');
}

function shouldUpdateClass(wrapper, input) {
  if (input.value !== '') {
    addFloatClass(wrapper);
  } else {
    removeFloatClass(wrapper);
  }
}

function registerFloatEventListners(wrapper, input) {
  input.addEventListener('focus', function(e) {
    addFloatClass(wrapper)
  }, false)
  input.addEventListener('blur', function(e){
    shouldUpdateClass(wrapper, input)
  }, false)
}


(function(){
  const allFloatWrappers = document.querySelectorAll('.fe__wrapper--float')

  for (var i = 0; i < allFloatWrappers.length; i++) {
    var wrapper = allFloatWrappers[i]
    const input = wrapper.querySelectorAll('.fe__input')[0]

    shouldUpdateClass(wrapper, input)
    registerFloatEventListners(wrapper, input);

  }
})();


// WEBPACK FOOTER //
// ./assets/js/forms/contactForm.js